var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-panel',{attrs:{"title":_vm.edit ? 'Editar objetivos' : 'Nuevos objetivos',"width":"short"},on:{"closePanel":_vm.closeModal}},[_c('goals-form',{attrs:{"edit":_vm.edit,"item":_vm.item,"item-type":_vm.itemType,"items":_vm.items,"goals":_vm.goals},on:{"onCreate":_vm.onCreate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd04169a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/goals/goals-create-panel.vue
// module id = null
// module chunks = 